import React, { useState } from "react";

function File_Attachment_Form_Edit() {
  const [showModal1, setShowModal1] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  const handleViewClick1 = () => {
    setShowModal1(true);
  };

  const closeModal1 = () => {
    setShowModal1(false);
  };

  const handleViewClick2 = () => {
    setShowModal2(true);
  };

  const closeModal2 = () => {
    setShowModal2(false);
  };

  return (
    <div className="p-5 border-2 border-gray-200 rounded-xl">
      {/* Title */}
      <div className="border-b pb-2">
        <p className="text-lg font-semibold text-gray-700">File Attachment</p>
      </div>

      {/* Table-like structure */}
      <div className="mt-5 flex px-5 flex-row flex-wrap">
        <table className="w-1/2 text-sm font-medium">
          <tbody>
            {/* Row 1 */}
            <tr>
              <td className="py-3 text-gray-700 w-1/2">Product Image :</td>
              <td
                onClick={handleViewClick1}
                className="py-3 underline cursor-pointer underline-offset-1 text-blue-500 w-1/2"
              >
                view
              </td>
            </tr>
            {/* Row 2 */}
            <tr>
              <td className="py-3 text-gray-700 w-1/2">
                Product Certification :
              </td>
              <td
                onClick={handleViewClick2}
                className="py-3 underline-offset-1 cursor-pointer text-blue-500 underline w-1/2"
              >
                view
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Modal for Product Certification */}
      {showModal2 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-fit max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Attached Files</h3>
              <button
                onClick={closeModal2}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="grid grid-cols-1 gap-4">
              <img
                src="https://picsum.photos/seed/image2/400/250"
                alt="Attachment 1"
                className="w-full h-auto rounded shadow"
              />
            </div>
            <div className="mt-6 flex justify-end">
              <button
                onClick={closeModal2}
                className="bg-[#0099E5] hover:bg-[#007FCC] text-white px-4 py-2 rounded text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal for Product Images */}
      {showModal1 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-1/2  overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Product Images</h3>
              <button
                onClick={closeModal1}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Dynamic Image Grid */}
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {[
                "https://picsum.photos/seed/image1/400/250",
                "https://picsum.photos/seed/image2/400/250",
                "https://picsum.photos/seed/image3/400/250",
                "https://picsum.photos/seed/image4/400/250",
                "https://picsum.photos/seed/image5/400/250",
                "https://picsum.photos/seed/image6/400/250",
                "https://picsum.photos/seed/image7/400/250",
                "https://picsum.photos/seed/image8/400/250",
                "https://picsum.photos/seed/image9/400/250",
                "https://picsum.photos/seed/image10/400/250",
                "https://picsum.photos/seed/image11/400/250",
                "https://picsum.photos/seed/image12/400/250",
              ].map((src, index) => (
                <img
                  key={index}
                  src={src}
                  alt={`Attachment ${index + 1}`}
                  className="w-full h-auto rounded shadow"
                />
              ))}
            </div>

            {/* Close Button */}
            <div className="mt-6 flex justify-end">
              <button
                onClick={closeModal1}
                className="bg-[#0099E5] hover:bg-[#007FCC] text-white px-4 py-2 rounded text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default File_Attachment_Form_Edit;
